import { Button, Input } from '@cokitchen/cokitchen-components';
import AddressInput from 'components/base/address-input';
import LocalModal from 'components/base/local-modal';
import useDashboardContext from 'contexts/dashboard.context';
import { AddressFormatType } from 'models/address.model';
import React, { useState } from 'react';
import { apiService } from 'services/base.service';
import bulkOrderService from 'services/bulk-order.service';
import { handleApiError } from 'utils/functions';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  name: string;
  setName: (item: string) => void;
};

const AddAddressModal = ({ isOpen, onClose, name, setName }: Props) => {
  const { refetchSavedAddressList } = useDashboardContext();

  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setValue('');
    onClose();
  };
  const saveAddresses = async (address: AddressFormatType) => {
    setLoading(true);
    try {
      await apiService.post(`user-saved-address`, {
        baseURL: process.env.REACT_APP_ORDER_API_URL,
        data: address
      });
      await refetchSavedAddressList();
    } catch (err) {
      handleApiError(err, 'Error saving address');
    } finally {
      handleClose();
      setLoading(false);
    }
  };

  const handleSaveAddress = async () => {
    try {
      const formattedAddress = await bulkOrderService.FormatAddress(value, name);
      saveAddresses(formattedAddress);
    } catch (err) {
      handleApiError(err, 'Error saving address');
    }
  };

  return (
    <LocalModal isOpen={isOpen} onRequestClose={handleClose} title='Add Address'>
      <div className='w-full'>
        <Input
          design='bordered'
          type='text'
          label='Location tag'
          optional
          placeholder='e.g Branch 1'
          className='mb-3'
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <AddressInput
          label='Address'
          placeholder='Enter address'
          value={value}
          onChange={setValue}
        />
        <div className='w-full flex gap-4 justify-end'>
          <Button
            variant='block'
            color='gray'
            className='mt-8 h-[41px] w-[139px] !bg-[#F2F2F2] !border-[#F2F2F2] !text-[#2E3031]'
            onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant='block'
            color='primary'
            className='mt-8 h-[41px] w-[139px]'
            disabled={value === ''}
            loading={loading}
            onClick={handleSaveAddress}>
            Save
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default AddAddressModal;
